module.exports = __webpack_public_path__ + "static/content-editor-1b32f3c5b25d7de1fb3ec9f2151959e1.png";